import 'sweetalert2/dist/sweetalert2.min.css';
import './assets/css/main.css';
import './assets/css/fontawesome/font-awesome-4.7.0.css';

import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './dashboard-plugin'
import VueCookies from 'vue-cookies'
import VueStripeCheckout from 'vue-stripe-checkout'
import { sync } from 'vuex-router-sync'

Vue.use(require('vue-moment'));
Vue.use(VueCookies)

// Plugins
import App from './App.vue'

// router setup
import store from './store'
import './ml'

const stripeOptions = {
  key: 'pk_test_U6haw0gKFGNsDo511OeyL9M8',
  image: '/static/img/alideda-new-logo.png',
  locale: 'auto',
  currency: 'EURO',
  billingAddress: false,
  panelLabel: 'Pay {{amount}}'
};

import JsonEditor from 'vue-json-edit'
Vue.use(JsonEditor)

// Plugins setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueStripeCheckout, stripeOptions);

// Global Mixin
import GlobalMixin from './mixins/global.mixin';
Vue.mixin(GlobalMixin);

// Snackbar
import VueSnackbar from 'vue-snack'
import 'vue-snack/dist/vue-snack.min.css'
Vue.use(VueSnackbar, { position: 'bottom-right', time: 3000 })

// Spinner
import Spinner from 'vue-simple-spinner';
Vue.component('spinner', Spinner);

// Sweet alert
import alert from 'vue-sweetalert2';
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
};
Vue.use(alert, options);

// Emoji 😄
import EmojiPicker from '@zaichaopan/emoji-picker';
Vue.use(EmojiPicker);

// Router
import router from './router/';
router.beforeEach((to, from, next) => {
  if (localStorage.getItem('role') && !['admin', 'reseller', 'client'].includes(localStorage.getItem('role'))) {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('CompanyId');
  }

  // Redirect to login if token doesn't exist
  if(!localStorage.getItem('token') && (to.name === undefined || to.name.indexOf('Auth') === -1)) {
    router.push('/auth/');
  } else {
    next();
    // If not admin, prevent routes which doesn't have 'role' in it's path
    if(!!localStorage.getItem('role') && localStorage.getItem('role') !== 'admin'
      && to.path.indexOf(localStorage.getItem('role')) === -1 && !['Contact', 'Help', 'Account'].includes(to.name)) {
      router.push('/' + localStorage.getItem('role') + '/');
    } else {
      next();
    }
  }
});

Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
});

sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});

/* We import element-ui variables at the end so they can override the default element-ui colors */
import './assets/sass/element_variables.scss'
